import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import SearchResultsPane from 'components/search/SearchResultsPane.vue';
import SearchBookPane from 'components/search/SearchBookPane.vue';
import {useSearchStore} from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPane',
  setup(__props) {

const searchStore = useSearchStore();


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createBlock(_component_q_splitter, {
    "model-value": _unref(searchStore).isTableModeSelected ? 100 : 40,
    class: "grouper-body-splitter iodine-padding-lg",
    limits: _unref(searchStore).isTableModeSelected ? [0, 100] : [40, 70],
    disable: _unref(searchStore).isTableModeSelected,
    "separator-style": "width: 6px; background-color: #F0F6FA;",
    "before-class": "iodine-border",
    "after-class": "iodine-border"
  }, {
    before: _withCtx(() => [
      _createVNode(SearchResultsPane)
    ]),
    after: _withCtx(() => [
      (!_unref(searchStore).isTableModeSelected)
        ? (_openBlock(), _createBlock(SearchBookPane, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "limits", "disable"]))
}
}

})